import React from 'react';
import PropTypes from 'prop-types';

import UserSearchMessage from './userSearchMessage';
import UserResultItem from './userResultItem';
import UserResultsSummary from './userResultsSummary';

const UserResultsHolder = props => {
  let userSearchResults;

  if (props.userSearchResults && props.userSearchResults.length > 0) {
    let index = -1;
    userSearchResults = props.userSearchResults.map(user => {
      index += 1;
      return (
        <UserResultItem
          key={user.employeeId}
          user={user}
          color={props.color}
          userResultClick={props.userResultClick}
          index={index}
          hoverSelectedUserIndex={props.hoverSelectedUserIndex}
          changeHoverSelectedUser={props.changeHoverSelectedUser}
        />
      );
    });
  }

  return (
    <div className="user-results-container">
      <div className="user-results">
        <ul className="user-list">
          {props.userSearchStatus === 'error' && (
            <UserSearchMessage
              errorMessage={props.translations['no-results-found']}
            />
          )}
          {props.userSearchStatus !== 'error' && userSearchResults}
        </ul>
      </div>
      {(props.userSearchStatus === 'searching' ||
        (props.userSearchResults && props.userSearchResults.length > 0)) && (
        <UserResultsSummary
          resultsText={props.translations.results}
          customizeSearchText={props.translations['customize-search']}
          userSearchResultsHeight={props.userSearchResultsHeight}
          resultsCount={props.userSearchResults.length}
          searchingMessage={props.translations.searching}
          userSearchStatus={props.userSearchStatus}
        />
      )}
    </div>
  );
};

UserResultsHolder.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  userSearchStatus: PropTypes.string.isRequired,
  userSearchResults: PropTypes.array,
  userSearchResultsHeight: PropTypes.string,
  userResultClick: PropTypes.func,
  hoverSelectedUserIndex: PropTypes.number,
  changeHoverSelectedUser: PropTypes.func,
  color: PropTypes.string,
};

UserResultsHolder.defaultProps = {
  userSearchResults: [],
  userSearchResultsHeight: '',
  userResultClick: () => {},
  hoverSelectedUserIndex: null,
  changeHoverSelectedUser: () => {},
  color: '',
};

export default UserResultsHolder;
